import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const Wrapper = styled.div`
  width: 100%;
`;

export const TrackerWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TextWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export const TrackerIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.theme.orderTracker.size};
  height: ${props => props.theme.orderTracker.size};
  background-color: ${props => props.active ? props.theme.orderTracker.iconColor.active : props.theme.orderTracker.iconColor.inactive};
  border-radius: 100%;
  flex-shrink: 0;
  transition: background-color 0.5s ease;
  &::before {
    font-family: 'icomoon';
    display: inline-block;
    color: ${props => props.theme.orderTracker.textColor};
  }
`;

export const OrderConfirm = TrackerIcon.extend`
  font-size: 3.8rem;
  &:before {
    content: '\\e002'
  }
`;

export const PreparingFood = TrackerIcon.extend`
  font-size: 3.3rem;
  &:before {
    content: '\\e006'
  }
`;

export const ReadyForCollection = TrackerIcon.extend`
  font-size: 2.9rem;
  &:before {
    content: '\\e004'
  }
`;

export const ReadyForDelivery = TrackerIcon.extend`
  font-size: 3rem;
  &:before {
    content: '\\e005'
  }
`;

export const ProgressBarStyled = styled.div`
  margin-left: ${props => props.theme.margin};
  margin-right: ${props => props.theme.margin};
  width: 50%;
  ${media.small`
    margin-left: 0.6rem;
    margin-right: 0.6rem;
    width: 100%;
  `};
`;

export const Info = styled.div`
  font-size: 1.4rem;
  width: 100%;
  text-align: ${props => props.align};
  color: ${props => props.active ? props.theme.orderTracker.iconColor.active : props.theme.orderTracker.iconColor.inactive};
`;



// WEBPACK FOOTER //
// ./containers/ConfirmationPage/OrderTracker.style.js